import React from 'react';
export const GuidesSection = () => {
  return <section className="bg-gradient-to-b from-teal-700 to-teal-800 text-white py-16" data-id="element-175">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-176">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-177">
          Meet Your Guides
        </h2>
        <div className="mb-10" data-id="element-178">
          <p className="text-lg text-center mb-12" data-id="element-179">
            At Neurotoned, you're not guided by influencers or generic
            instructors.
            <br data-id="element-180" />
            You're supported by a team of world-class somatic experts,
            therapists, and psychologists who live and breathe this work — and
            have walked the healing path themselves.
          </p>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-181">
            <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg h-full" data-id="element-182">
              <div className="flex flex-col items-center" data-id="element-183">
                <div className="w-40 h-40 mb-4" data-id="element-184">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ebPkLukCD8HVG1rCyKuqe3/a72d7f-b65f-f3f-db31-1bd8fccf7dda_b5678e5b-b47a-449f-a3a7-7890b1473025_%283%29.webp" alt="Dr. Kim DiRe'" className="w-full h-full object-cover rounded-full shadow-lg" data-id="element-185" />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-center" data-id="element-186">
                  Dr. Kim DiRe'
                </h3>
                <p className="text-lg text-center" data-id="element-187">
                  Dr. Kim is a doctor of behavioral health with a master's in
                  education and counseling. She's certified in hypnotherapy,
                  childhood obesity, and Somatic Experiencing™ — and has helped
                  thousands through her original trauma recovery trainings,
                  books, and healing journal.
                </p>
              </div>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg h-full" data-id="element-188">
              <div className="flex flex-col items-center" data-id="element-189">
                <div className="w-40 h-40 mb-4" data-id="element-190">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6Enk4EhEAka7z29kGzP3R8/238d00-c24b-05ab-216d-f0a0ba0aefc4_Demi-Gea_%282%29.webp" alt="Demi-Gea Hart" className="w-full h-full object-cover rounded-full shadow-lg" data-id="element-191" />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-center" data-id="element-192">
                  Demi-Gea Hart
                </h3>
                <p className="text-lg text-center" data-id="element-193">
                  Demi-Gea is a holistic psychologist known for blending science
                  with soulful depth. She integrates hypnosis, breath therapy,
                  yoga, and meditation to create lasting transformation. Her
                  work honors the whole self — mind, body, and spirit.
                </p>
              </div>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg h-full" data-id="element-194">
              <div className="flex flex-col items-center" data-id="element-195">
                <div className="w-40 h-40 mb-4" data-id="element-196">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o4PsmpSTcRYnvzGxhtTzaY/eb150f5-a753-71d2-215-faa6a5f4077_a2774aed-8d87-46e6-a1c7-aedd8eceeb8d.webp" alt="Taryn Elise Herselman" className="w-full h-full object-cover rounded-full shadow-lg" data-id="element-197" />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-center" data-id="element-198">
                  Taryn Elise Herselman
                </h3>
                <p className="text-lg text-center" data-id="element-199">
                  Taryn is a yoga therapist with 15+ years of experience and a
                  master's degree in psychology. Trained in India, she
                  specializes in Hatha, Yin, and Restorative Yoga to support
                  emotional healing. Her presence is grounding and nurturing.
                </p>
              </div>
            </div>
            <div className="bg-white bg-opacity-10 p-6 rounded-lg shadow-lg h-full" data-id="element-200">
              <div className="flex flex-col items-center" data-id="element-201">
                <div className="w-40 h-40 mb-4" data-id="element-202">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/txGXLCpsmDHAZwir3pSdqo/0dc5dca-8644-b0-528-e014e377254_Jeri_Image_3.webp" alt="Jeri Silverman" className="w-full h-full object-cover rounded-full shadow-lg" data-id="element-203" />
                </div>
                <h3 className="text-2xl font-bold mb-3 text-center" data-id="element-204">
                  Jeri Silverman
                </h3>
                <p className="text-lg text-center" data-id="element-205">
                  Jeri is a Somatic Experiencing™ practitioner and Alexander
                  Technique teacher based in Cape Town. She specializes in using
                  voice, breath, and embodied movement for trauma resolution,
                  drawing from Archetypal Psychology and mindfulness traditions.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};